/* Grid images Slider section 
--------------------------------------*/

class ImageGallerySlider {
  constructor (parent) {
    this.parent = parent;
    if (!this.parent) {
      return;
    }
    this.slider();
  }

  slider = () => {
    let sliders = qsa('.image-gallery-slider-js');
    sliders?.forEach(element => {
      let gallerySliderSectionId = element.dataset.id;
      let gallerySliderSlide = element.dataset.slide;
      let gallerySliderClass = `.image-gallery-slider-js.${gallerySliderSectionId}`;
      let mobileGallerySliderSlide = '2.25';
      if(element.classList.contains("gallery-slider-small-js") && window.innerWidth < 768){
        mobileGallerySliderSlide = '3.1';
      }
      this.gallerySlider(gallerySliderClass,gallerySliderSlide,mobileGallerySliderSlide);
    });
  }
  gallerySlider = (sliderClass,gallerySliderSlide,mobileGallerySliderSlide) => {
    let activeSlide = true;
    if (window.innerWidth > 767) {
      if (!qs(sliderClass).classList.contains('slider-active-js')) {
        activeSlide = false;
      }
    }
    if (activeSlide) {
      const recommendationSlider = new Swiper(sliderClass, {
        loop: false,
        slidesPerView: gallerySliderSlide,
        slidesPerGroup: 1,
        shortSwipes: true,
        shortSwipesRatio: 0,
        speed: 1000,
        resistanceRatio:0.4,
        autoHeight:false,
        spaceBetween: 20,
        breakpoints: {
          1: {
            slidesPerView: mobileGallerySliderSlide,
            spaceBetween: 10,
            resizeReInit: false,
            pagination:false,
            navigation:false,
          },
          768: {
            slidesPerView: 3.25,
            resizeReInit: false,
            spaceBetween: 10,
            pagination:false,
            navigation:false,
          },
          1024: {
            slidesPerView: gallerySliderSlide,
          },
        },
        // Navigation arrows
        navigation: {
          nextEl: `${sliderClass} ~ .swiper-button-next.gallery-arrow`,
          prevEl: `${sliderClass} ~ .swiper-button-prev.gallery-arrow`,
        },
        // Pagination dots
        pagination: {
          el: `.swiper-pagination.gallery-pagination`,
          type: 'bullets',
          clickable : true
        },
      });
    }
  }

}
new ImageGallerySlider(qs('.image-gallery-slider-js'));